import { MediaAssetOrientation } from '@calm/evexia-web-sdk';
import { useMediaQuery } from '@rhg/libs/material';

export function useCurrentViewportOrientation(): MediaAssetOrientation {
    const isPortrait = useMediaQuery('(orientation: portrait)');
    return isPortrait
        ? MediaAssetOrientation.Portrait
        : MediaAssetOrientation.Landscape;
}
